import { useState } from "react";

import CommonInput from "@/components/Common/Input";
import CommonPlusButton from "@/components/Common/PlusButton";
import KeywordItem from "@/components/KeywordItem";
import { isNotEmpty } from "@/libs/utils";

type Props = {
  label: string;
  data: string[];
  setData: (list: string[]) => void;
};
export default function KeywordExcludeItem({ label, data, setData }: Props) {
  const [inputText, setInputText] = useState<string>("");

  const handleClickPlus = () => {
    if (isNotEmpty(inputText)) {
      setData([...data.concat(inputText)]);
      setInputText("");
    }
  };

  const handleDeleteItem = (index: number) => {
    setData([...data.toSpliced(index, 1)]);
  };

  return (
    <div className="flex gap-[8px] items-center">
      <div className="min-w-[104px] text-[12px] text-gray-B font-bold">
        {label}
      </div>
      <CommonInput
        className="min-w-[232px]"
        defaultValue={inputText}
        placeholder="키워드를 입력해보세요"
        onChange={(value) => setInputText(value)}
        onKeyDownEnter={() => {
          handleClickPlus();
        }}
      />
      <CommonPlusButton onClick={handleClickPlus} />
      <div className="flex gap-[8px] overflow-x-auto">
        {data.map((item, index) => (
          <KeywordItem
            key={index}
            index={index}
            label={item}
            className="bg-pink"
            onDelete={() => handleDeleteItem(index)}
          />
        ))}
      </div>
    </div>
  );
}
